import { render, staticRenderFns } from "./PH1V_S18.vue?vue&type=template&id=07c7c01b&scoped=true"
import script from "./PH1V_S18.vue?vue&type=script&lang=js"
export * from "./PH1V_S18.vue?vue&type=script&lang=js"
import style0 from "./PH1V_S18.vue?vue&type=style&index=0&id=07c7c01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7c01b",
  null
  
)

export default component.exports